// Central runtime configuration. Values resolve in this order:
//   0. Explicit CRA env vars in development (local launch profiles)
//   1. window.__RUNTIME_CONFIG__ (public/runtime-config.js, per-environment)
//   2. process.env (CRA build-time REACT_APP_* vars)
//   3. hardcoded fallback

function read(key: string, envKey: string, fallback: string): string {
  const fromEnv = process.env[envKey];
  if (process.env.NODE_ENV === 'development' && fromEnv !== undefined && fromEnv !== '') {
    return fromEnv;
  }
  const runtime = typeof window !== 'undefined' ? window.__RUNTIME_CONFIG__ : undefined;
  const fromRuntime = runtime?.[key];
  if (fromRuntime !== undefined && fromRuntime !== '') return fromRuntime;
  if (fromEnv !== undefined && fromEnv !== '') return fromEnv;
  return fallback;
}

function stripTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '');
}

// The hibernate data-service gateway. Everything (AI + payments) is proxied through it.
export const DATA_SERVICE_BASE_URL = stripTrailingSlash(
  read(
    'DATA_SERVICE_BASE_URL',
    'REACT_APP_DATA_SERVICE_BASE_URL',
    'https://hibernate-service-491484225296.us-central1.run.app',
  ),
);

// AI service, reached through the gateway proxy. Streaming uses a dedicated proxy path.
export const AI_SERVICE_BASE_URL = `${DATA_SERVICE_BASE_URL}/api/proxy/ai-service`;
export const AI_STREAMING_BASE_URL = `${DATA_SERVICE_BASE_URL}/api/proxy/ai-service-stream`;

// Payments service, reached through the gateway proxy.
export const PAYMENTS_SERVICE_BASE_URL = `${DATA_SERVICE_BASE_URL}/api/proxy/payments-service`;

export const STRIPE_PUBLISHABLE_KEY = read('STRIPE_PUBLISHABLE_KEY', 'REACT_APP_STRIPE_PUBLISHABLE_KEY', '');

// Empty => ad slots render as visible placeholders instead of loading AdSense.
export const ADSENSE_CLIENT_ID = read('ADSENSE_CLIENT_ID', 'REACT_APP_ADSENSE_CLIENT_ID', '');

// Per-format ad unit (slot) ids from the AdSense dashboard. Empty => placeholder.
export const ADSENSE_SLOT_BANNER = read('ADSENSE_SLOT_BANNER', 'REACT_APP_ADSENSE_SLOT_BANNER', '');
export const ADSENSE_SLOT_RECTANGLE = read('ADSENSE_SLOT_RECTANGLE', 'REACT_APP_ADSENSE_SLOT_RECTANGLE', '');

export const GOOGLE_OAUTH_ENABLED =
  read('GOOGLE_OAUTH_ENABLED', 'REACT_APP_GOOGLE_OAUTH_ENABLED', 'true') === 'true';
